import React from "react";
import { useNavigate } from "react-router-dom";

const plans = [
  {
    title: "Abonnement Premium",
    description: "Accédez à toutes les fonctionnalités de Zemus : suivi de la presse, revues, favoris et forums.",
    cta: "Voir les abonnements",
    path: "/Subscription",
  },
  {
    title: "Achat de pays",
    description: "Achetez des pays à l'unité pour rechercher dans leur presse.",
    cta: "Acheter des pays",
    path: "/purchase-countries",
  },
  {
    title: "Tokens Zemus IA",
    description: "Rechargez vos tokens pour utiliser les fonctionnalités d'intelligence artificielle.",
    cta: "Acheter des tokens IA",
    path: "/ai-tokens",
  },
];

export default function ZemusPlans() {
  const navigate = useNavigate();

  return (
    <div className="max-w-6xl mx-auto px-4 py-8">
      <h1 className="text-2xl md:text-3xl font-semibold text-center mb-8">Forfaits Zemus</h1>
      <div className="flex flex-col md:flex-row gap-6 justify-center items-stretch">
        {plans.map((plan) => (
          <div key={plan.path} className="flex flex-col flex-1 bg-white rounded-2xl shadow-lg overflow-hidden">
            <div className="bg-[#009AAD] py-4 text-center">
              <h2 className="text-xl text-white font-medium">{plan.title}</h2>
            </div>
            <div className="flex flex-col flex-1 justify-between p-6 gap-6">
              <p className="text-left">{plan.description}</p>
              <button
                type="button"
                onClick={() => navigate(plan.path)}
                className="bg-yellow-400 text-black font-medium px-6 py-3 rounded-full hover:bg-yellow-500 transition-colors"
              >
                {plan.cta}
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
